// Generates the onboarding Excel template entirely in the browser using window.XLSX.
// Mirrors scripts/generateOnboardingTemplate.js — keep both in sync when adding columns.

const centerHeaders = [
  'centreName', 'centerRole', 'type', 'phoneNumber', 'countryCode', 'email',
  'address_floor', 'address_area', 'address_city', 'address_state', 'address_pincode',
  'address_country', 'address_fulladdress', 'address_latitude', 'address_longitude',
  'billing_name', 'billing_code', 'billing_taxId', 'billing_isSameAsAddress',
  'billing_line', 'billing_city', 'billing_state', 'billing_pincode',
  'abha_facility_id', 'canInterpretReport', 'hub_center_ids', 'tempCenterId',
];

const centerNotes = [
  '* Required. Name of this specific centre (not the business/org name)',
  '* Required. Must be exactly: Hub Centre OR Spoke Centre',
  '* Required. One of: Private Practice Clinic | Private Diagnostic centre | Government Facility | Private AYUSH clinic | Private Hospital',
  'Optional. 10-digit number without country code',
  'Default: +91',
  'Optional. Centre email',
  'Optional. Floor / Building number',
  'Optional. Area / Street',
  'Optional. City (used in full address)',
  'Optional. State (used in full address)',
  'Optional. 6-digit pincode (used in full address)',
  'Optional. Default: India',
  '* Required. Full address string — paste the complete address here',
  'Optional. Decimal latitude (for map pin)',
  'Optional. Decimal longitude (for map pin)',
  '* Required. Billing entity name',
  '* Required. Tax state code (e.g. UP, MH)',
  '* Required. GST / Tax ID',
  'Optional. TRUE or FALSE — if TRUE billing address auto-copies from above',
  '* Required. Billing address line',
  '* Required. Billing city',
  '* Required. Billing state',
  '* Required. Billing pincode',
  'Optional. ABHA facility ID',
  'Optional. TRUE = this centre can interpret ECG reports. Default: FALSE',
  'Optional. For Spoke Centre: enter the tempCenterId of the parent Hub (e.g. C1).',
  '* Required for member mapping. Short unique ID you assign e.g. C1, C2. Not sent to server.',
];

const centerHub1 = [
  'Sunfox Dehradun Hub', 'Hub Centre', 'Government Facility', '8126444355', '+91', 'dehradun@sunfox.in',
  '2nd Floor', 'Rajpur Road', 'Dehradun', 'Uttarakhand', '248001', 'India',
  '2nd Floor, Rajpur Road, Dehradun, Uttarakhand, 248001', '30.3165', '78.0322',
  'Sunfox Health Hub Pvt Ltd', 'UK', 'GSTIN123456', 'FALSE',
  '2nd Floor, Rajpur Road, Dehradun', 'Dehradun', 'Uttarakhand', '248001',
  'ABHA_FAC_001', 'TRUE', '', 'C1',
];
const centerSpoke1A = [
  'Sunfox Rishikesh Spoke', 'Spoke Centre', 'Private Practice Clinic', '8008760101', '+91', 'rishikesh@sunfox.in',
  'Ground Floor', 'Haridwar Road', 'Rishikesh', 'Uttarakhand', '249201', 'India',
  'Ground Floor, Haridwar Road, Rishikesh, Uttarakhand, 249201', '30.0869', '78.2676',
  'Sunfox Health Hub Pvt Ltd', 'UK', 'GSTIN123456', 'FALSE',
  'Ground Floor, Haridwar Road, Rishikesh', 'Rishikesh', 'Uttarakhand', '249201',
  '', 'FALSE', 'C1', 'C2',
];
const centerSpoke1B = [
  'Sunfox Haridwar Spoke', 'Spoke Centre', 'Private Diagnostic centre', '8008760102', '+91', 'haridwar@sunfox.in',
  'Shop No. 5', 'Jwalapur Road', 'Haridwar', 'Uttarakhand', '249407', 'India',
  'Shop No. 5, Jwalapur Road, Haridwar, Uttarakhand, 249407', '29.9457', '78.1642',
  'Sunfox Health Hub Pvt Ltd', 'UK', 'GSTIN123456', 'FALSE',
  'Shop No. 5, Jwalapur Road, Haridwar', 'Haridwar', 'Uttarakhand', '249407',
  '', 'FALSE', 'C1', 'C3',
];
const centerSpoke1C = [
  'Sunfox Roorkee Spoke', 'Spoke Centre', 'Private Hospital', '8008760103', '+91', 'roorkee@sunfox.in',
  '1st Floor', 'Civil Lines', 'Roorkee', 'Uttarakhand', '247667', 'India',
  '1st Floor, Civil Lines, Roorkee, Uttarakhand, 247667', '29.8543', '77.8880',
  'Sunfox Health Hub Pvt Ltd', 'UK', 'GSTIN123456', 'FALSE',
  '1st Floor, Civil Lines, Roorkee', 'Roorkee', 'Uttarakhand', '247667',
  '', 'FALSE', 'C1', 'C4',
];
const centerHub2 = [
  'Sunfox Delhi Hub', 'Hub Centre', 'Private Hospital', '8126444356', '+91', 'delhi@sunfox.in',
  '3rd Floor', 'Connaught Place', 'New Delhi', 'Delhi', '110001', 'India',
  '3rd Floor, Connaught Place, New Delhi, Delhi, 110001', '28.6315', '77.2167',
  'Sunfox Health Hub Pvt Ltd', 'DL', 'GSTIN789012', 'FALSE',
  '3rd Floor, Connaught Place, New Delhi', 'New Delhi', 'Delhi', '110001',
  'ABHA_FAC_002', 'TRUE', '', 'C5',
];
const centerSpoke2A = [
  'Sunfox Noida Spoke', 'Spoke Centre', 'Private Diagnostic centre', '8008760201', '+91', 'noida@sunfox.in',
  'Ground Floor', 'Sector 18', 'Noida', 'Uttar Pradesh', '201301', 'India',
  'Ground Floor, Sector 18, Noida, Uttar Pradesh, 201301', '28.5708', '77.3260',
  'Sunfox Health Hub Pvt Ltd', 'UP', 'GSTIN789012', 'FALSE',
  'Ground Floor, Sector 18, Noida', 'Noida', 'Uttar Pradesh', '201301',
  '', 'FALSE', 'C5', 'C6',
];
const centerSpoke2B = [
  'Sunfox Gurgaon Spoke', 'Spoke Centre', 'Private Practice Clinic', '8008760202', '+91', 'gurgaon@sunfox.in',
  '2nd Floor', 'DLF Cyber City', 'Gurugram', 'Haryana', '122002', 'India',
  '2nd Floor, DLF Cyber City, Gurugram, Haryana, 122002', '28.4951', '77.0888',
  'Sunfox Health Hub Pvt Ltd', 'HR', 'GSTIN789012', 'FALSE',
  '2nd Floor, DLF Cyber City, Gurugram', 'Gurugram', 'Haryana', '122002',
  '', 'FALSE', 'C5', 'C7',
];

const memberHeaders = [
  'firstName', 'middleName', 'lastName', 'email', 'phoneNumber', 'countryCode',
  'virtualId', 'defaultPassword', 'age', 'gender', 'dateOfBirth', 'profession',
  'qualification', 'medicalLicenseNumber', 'role', 'designation', 'centerIds',
  'perm_canManageUsers', 'perm_canViewRequests', 'perm_canManageRequests',
  'perm_canViewReports', 'perm_canShareReports', 'perm_canSendForInterpretation',
  'perm_canInterpreteReport', 'perm_canAccessApp', 'perm_canReferCases', 'perm_canViewCases',
];

const memberNotes = [
  '* Required.', 'Optional.', 'Optional.', 'Optional.',
  '* Required if no virtualId. 10-digit without country code.',
  'Default: +91',
  '* Required if no phoneNumber. Short alphanumeric ID e.g. 34DFRQE',
  'Recommended. Default password for first login.',
  'Optional. Age in years (number).',
  '* Required. One of: Male | Female | Other',
  '* Required. Format: DD-MM-YYYY  e.g. 15-08-1990',
  '* Required. One of: Doctor | Nurse | Lab Technician | Pharmacist | Non-Medical Professional | Medical Student | Diagnostics Professional | Other Medical Professional',
  'Optional. e.g. MBBS,MD  (comma-separated)',
  'Optional. Medical license/registration number.',
  '* Required. One of: b2b-admin | b2b-member | b2b-doctor | b2b-viewer',
  'Optional. e.g. Cardiologist / Nurse / Technician',
  '* Required. Comma-separated tempCenterId values from Centers sheet (e.g. C1,C2).',
  'TRUE | FALSE — Add and remove users',
  'TRUE | FALSE — View collection requests',
  'TRUE | FALSE — Create/delete collection requests',
  'TRUE | FALSE — View and download ECG reports',
  'TRUE | FALSE — Share ECG reports with patients',
  'TRUE | FALSE — Send ECG for interpretation',
  'TRUE | FALSE — Interpret ECG reports (b2b-doctor only)',
  'TRUE | FALSE — Can log in to the app',
  'TRUE | FALSE — Add to referred cases (b2b-doctor only)',
  'TRUE | FALSE — View referred cases (b2b-doctor only)',
];

const memberAdmin  = ['Abhishek', '', 'Negi',   'abhishek@sunfox.in', '8008760001', '+91', '34DFRQE', '#Abhishek#2001', 35, 'Male',   '10-05-1990', 'Non-Medical Professional', '',        '',          'b2b-admin',  'Manager',         'C1,C2,C3', 'TRUE',  'TRUE',  'TRUE',  'TRUE',  'TRUE',  'TRUE',  'FALSE', 'TRUE',  'FALSE', 'FALSE'];
const memberDoctor = ['Dr. Priya', '', 'Sharma', 'priya@sunfox.in',   '8008760002', '+91', '',        '#Priya#2001',    42, 'Female', '22-03-1983', 'Doctor',                  'MBBS,MD', 'MCI-12345', 'b2b-doctor', 'Cardiologist',    'C1,C2',    'FALSE', 'FALSE', 'FALSE', 'TRUE',  'FALSE', 'TRUE',  'TRUE',  'TRUE',  'TRUE',  'TRUE'];
const memberTech   = ['Rahul',     '', 'Verma',  'rahul@sunfox.in',   '8008760003', '+91', '',        '#Rahul#2001',    28, 'Male',   '05-11-1996', 'Lab Technician',          '',        '',          'b2b-member', 'ECG Technician',  'C2',       'FALSE', 'TRUE',  'TRUE',  'FALSE', 'FALSE', 'FALSE', 'FALSE', 'TRUE',  'FALSE', 'FALSE'];
const memberViewer = ['Sita',      '', 'Rawat',  'sita@sunfox.in',    '8008760004', '+91', '',        '#Sita#2001',     31, 'Female', '18-07-1994', 'Non-Medical Professional', '',       '',          'b2b-viewer', 'Supervisor',      'C5,C6',    'FALSE', 'FALSE', 'FALSE', 'TRUE',  'FALSE', 'FALSE', 'FALSE', 'FALSE', 'FALSE', 'FALSE'];

const refData = [
  ['ROLES', '', 'CENTER TYPES', '', 'PERMISSIONS GUIDE'],
  ['b2b-admin',  'Full access: manage users, reports, collections',  'Hub Centre',   'Main/parent centre',         'canManageUsers — Add/remove/edit team members'],
  ['b2b-member', 'Manage collections & view reports (no user mgmt)', 'Spoke Centre', 'Sub-centre linked to a hub', 'canViewRequests — View test collection requests'],
  ['b2b-doctor', 'Interpret ECG reports and manage referred cases',  '',             '',                           'canManageRequests — Create/delete test collections'],
  ['b2b-viewer', 'Read-only: view reports and analytics only',       '',             '',                           'canViewReports — View and download ECG reports'],
  ['', '', '', '', 'canShareReports — Share ECG reports with patients'],
  ['', '', '', '', 'canSendForInterpretation — Send ECG for interpretation'],
  ['', '', '', '', 'canInterpreteReport — Interpret ECG reports (b2b-doctor only)'],
  ['', '', '', '', 'canAccessApp — Can log into mobile/Android app'],
  ['', '', '', '', 'canReferCases — Add to referred cases (b2b-doctor only)'],
  ['', '', '', '', 'canViewCases — View referred cases (b2b-doctor only)'],
  [],
  ['HOW tempCenterId WORKS'],
  ['Step 1', 'In the Centers sheet, assign a short unique ID to each centre in the tempCenterId column (e.g. C1, C2, C3 …).'],
  ['Step 2', "For Spoke centres, enter the parent Hub's tempCenterId in the hub_center_ids column (e.g. C1). Import resolves it automatically."],
  ['Step 3', 'In Members sheet → centerIds, enter comma-separated tempCenterId values (e.g. C1,C2,C3). Import resolves each to a real api_key.'],
  ['Step 4', 'Upload the file. Centres are created first (top-to-bottom), then members. Everything links up automatically.'],
  [],
  ['VALID CENTER TYPES'],
  ['Private Practice Clinic', '', 'Private Diagnostic centre', '', 'Government Facility'],
  ['Private AYUSH clinic', '', 'Private Hospital', '', ''],
  [],
  ['VALID PROFESSIONS'],
  ['Doctor', '', 'Nurse', '', 'Lab Technician'],
  ['Pharmacist', '', 'Non-Medical Professional', '', 'Medical Student'],
  ['Diagnostics Professional', '', 'Other Medical Professional', '', ''],
  [],
  ['IMPORTANT NOTES'],
  ['1.', 'Row 1 = column headers. Row 2 = notes/descriptions. Data starts from Row 3. Do NOT edit or delete rows 1–2.'],
  ['2.', 'tempCenterId is only used inside this Excel for mapping — it is never sent to the server.'],
  ['3.', 'Hub centres must appear BEFORE their spokes in the Centers sheet (import processes rows top-to-bottom).'],
  ['4.', 'defaultPassword: min 8 characters, at least 1 uppercase letter and 1 special character (e.g. #Abcd@2024).'],
  ['5.', 'phoneNumber OR virtualId is required for each member. Both can be provided.'],
  ['6.', 'Leave optional fields blank — do NOT delete the column.'],
  ['7.', 'gender must be exactly: Male | Female | Other'],
  ['8.', 'dateOfBirth format: DD-MM-YYYY  e.g. 15-08-1990'],
  ['9.', 'Permission dependency: canAccessApp auto-enables canManageRequests + canViewRequests.'],
  ['10.', 'canInterpreteReport and case permissions are only meaningful for b2b-doctor role.'],
];

export function generateTemplateWorkbook(XLSX) {
  const wb = XLSX.utils.book_new();

  const wsCenter = XLSX.utils.aoa_to_sheet([
    centerHeaders, centerNotes,
    centerHub1, centerSpoke1A, centerSpoke1B, centerSpoke1C,
    centerHub2, centerSpoke2A, centerSpoke2B,
  ]);
  wsCenter['!cols'] = centerHeaders.map(() => ({ wch: 28 }));
  XLSX.utils.book_append_sheet(wb, wsCenter, 'Centers');

  const wsMember = XLSX.utils.aoa_to_sheet([
    memberHeaders, memberNotes,
    memberAdmin, memberDoctor, memberTech, memberViewer,
  ]);
  wsMember['!cols'] = memberHeaders.map(() => ({ wch: 26 }));
  XLSX.utils.book_append_sheet(wb, wsMember, 'Members');

  const wsRef = XLSX.utils.aoa_to_sheet(refData);
  wsRef['!cols'] = [{ wch: 12 }, { wch: 72 }, { wch: 26 }, { wch: 10 }, { wch: 58 }];
  XLSX.utils.book_append_sheet(wb, wsRef, 'Reference');

  return wb;
}
